import { IS_ETS_NEXT } from '@/utils/constants';

const productsFeatures = [
  {
    displayName: 'QC, Mail, Ticketing',
    key: 'qcMailTicketing',
    features: [
      { displayName: 'Schedules', key: 'qcMailTicketingSchedules' },
      { displayName: 'Tables', key: 'qcMailTicketingTables' },
      { displayName: 'ResRules', key: 'qcMailTicketingResrules' },
      { displayName: 'Messaging', key: 'qcMailTicketingMessaging' },
      {
        displayName: 'Reporting and Analytics',
        key: 'qcMailTicketingReportingAndAnalytics',
      },
      { displayName: 'Data Insights', key: 'qcMailTicketingDataInsights' },
      {
        displayName: 'Demo - Reporting and Analytics',
        key: 'qcMailTicketingDemoReportingAndAnalytics',
      },
    ],
  },
  {
    displayName: 'Queue Monitor',
    key: 'queueMonitor',
    features: [
      { displayName: 'Configuration', key: 'queueMonitorConfiguration' },
    ],
  },
  {
    displayName: 'Travel Authorization',
    key: 'travelAuthorization',
    features: [
      {
        displayName: 'Pending Requests',
        key: 'travelAuthorizationPendingRequests',
      },
      {
        displayName: 'Search Requests',
        key: 'travelAuthorizationSearchRequests',
      },
      {
        displayName: 'Travel Policy',
        key: 'travelAuthorizationTravelPolicy',
      },
      { displayName: 'Meetings', key: 'travelAuthorizationMeetings' },
      {
        displayName: 'Business Insights',
        key: 'travelAuthorizationBusinessInsights',
      },
      {
        displayName: 'Transaction Logs',
        key: 'travelAuthorizationTransactionLogs',
      },
      {
        displayName: 'Document Logs',
        key: 'travelAuthorizationDocumentLogs',
      },
    ],
  },
  {
    displayName: 'TicketTRAK',
    key: 'tickettrak',
    features: [
      { displayName: 'Configuration', key: 'tickettrakConfiguration' },
    ],
  },
  {
    displayName: 'Table Connector',
    key: 'tableConnector',
    features: [],
  },
  {
    displayName: 'Event Driven Actions',
    key: 'eda',
    features: [{ displayName: 'Configuration', key: 'edaConfiguration' }],
  },
  {
    displayName: 'iBank Reporting',
    key: 'ibankReporting',
    features: [
      { displayName: 'Log in to iBank', key: 'ibankReportingLogin' },
      { displayName: 'Event Logs', key: 'ibankReportingEventLogs' },
      { displayName: 'Hub Link in iBank', key: 'ibankReportingHubLink' },
    ],
  },
  {
    displayName: 'Administration',
    key: 'administration',
    features: [
      {
        displayName: 'Site Configuration',
        key: 'administrationSiteConfiguration',
      },
      {
        displayName: 'Asset Management',
        key: 'administrationAssetManagement',
      },
      { displayName: 'User Management', key: 'administrationUserManagement' },
      { displayName: 'Role Management', key: 'administrationRoleManagement' },
      {
        displayName: 'User Impersonation',
        key: 'administrationUserImpersonation',
      },
      { displayName: 'Activity Logs', key: 'administrationActivityLogs' },
    ],
  },
];

const internalOnlyFeatures = [
  { displayName: 'Organizations', key: 'cisInternalOrganizations' },
  { displayName: 'Libraries', key: 'cisInternalLibraries' },
  { displayName: 'Schedule Mover', key: 'cisInternalScheduleMover' },
  { displayName: 'Engine Monitor', key: 'cisInternalEngineMonitor' },
  { displayName: 'Queue Monitor', key: 'cisInternalQueueMonitor' },
  {
    displayName: 'iQCX Alert Notifications',
    key: 'cisInternalIqcxAlertNotifications',
  },
  {
    displayName: 'Email Notifications',
    key: 'cisInternalEmailNotifications',
  },
  {
    displayName: 'Dynamic Reporting',
    key: 'cisInternalDynamicReporting',
  },
  { displayName: 'GTR Stats', key: 'cisInternalGtrStats' },
  { displayName: 'Feature Flags', key: 'cisInternalFeatureFlags' },
];

// Maps to the key field in productsFeatures.
export const etsNextLockedDownModules = [
  'travelAuthorization',
  'tableConnector',
  'ibankReporting',
];

export const etsNextLockedDownFeatures = [
  'qcMailTicketingReportingAndAnalytics',
  'qcMailTicketingDataInsights',
  'qcMailTicketingDemoReportingAndAnalytics',
  'cisInternalDynamicReporting',
];

export function getProductsFeatures() {
  let features = productsFeatures;
  if (IS_ETS_NEXT)
    features = features
      .filter((product) => !etsNextLockedDownModules.includes(product.key)) // Remove locked-down modules
      .map((product) => ({
        ...product,
        features: product?.features?.filter(
          (feature) => !etsNextLockedDownFeatures.includes(feature.key) // Remove locked-down features
        ),
      }));

  return features;
}

export function getInternalOnlyFeatures() {
  let features = internalOnlyFeatures;
  if (IS_ETS_NEXT)
    features = features.filter(
      (product) => !etsNextLockedDownFeatures.includes(product.key)
    );
  return features;
}

export function getAllModuleKeys() {
  const productsFeatures = getProductsFeatures();

  let keys = productsFeatures.map((product) => product.key);
  keys.push('cisInternal');

  return keys;
}

export function getAllFeatureKeys() {
  const productsFeatures = getProductsFeatures();
  const internalOnlyFeatures = getInternalOnlyFeatures();

  let keys = productsFeatures.reduce((acc, product) => {
    product.features.forEach((feature) => {
      acc.push(feature.key);
    });
    return acc;
  }, []);

  internalOnlyFeatures.forEach((feature) => {
    keys.push(feature.key);
  });

  return keys;
}
